import React from 'react';
import ContractingPeriodSelection from '../../../tc-ui/contractingPeriodsSelection';
import RateTypeForm from '../../generic-components/rate-forms/RateType';
import ExpandLessIcon from 'material-ui/svg-icons/navigation/expand-less';
import { JiraFlatButton } from '../../../tc-ui/small-buttons';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import SelectLocationsProducts
  from './select-locations-products';
import R from 'ramda';
import { fromJS } from 'immutable';
import moment from 'moment';
// How many cities do you operate in?
// We operate in one city/region.  We operate in multiple cities/regions.
// How many properties do you own/manage?
// We own/manage one property.    We own/manage multiple properties.
export default props => {
  const {
    newDraftStartDate,
    newDraftEndDate,
    templateName,
    draftRateType,
    draftCommissionPercentage,
    draftNettCommission,
    oneOrMulti,
    locations = [],
    updateProps,
    datesInEditMode,
  } = props;
  const onClickEditDates = () => updateProps({ datesInEditMode: true });
  const minimize = () => updateProps({ datesInEditMode: false });
  return (
    <div style={{ marginTop: '30px' }}>
      <div style={{ margin: '0.5em 0 1em 0', width: '480px' }} className="flex-center">
        <b>Contracting Period:</b>
        <span>&nbsp;&nbsp;&nbsp;
          {moment.utc(new Date(newDraftStartDate)).format('MMM DD YYYY')} - {moment.utc(new Date(newDraftEndDate)).format('MMM DD YYYY')}
        </span>&nbsp;&nbsp;&nbsp;
        {
          datesInEditMode
          ? (
            <JiraFlatButton
              icon={<ExpandLessIcon/>}
              label="Minimize"
              onClick={minimize}
            />
          )
          : (
            <JiraFlatButton icon={<EditIcon/>} onClick={onClickEditDates} label="Edit"/>
          )
        }
      </div>
      {
        Boolean(datesInEditMode) && (
          <div
            style={{
              backgroundColor: '#fafafa',
              borderRadius: '5px',
              padding: '8px 16px',
              border: '1px solid #e0e0e0',
              marginBottom: '16px',
            }}
          >
            <ContractingPeriodSelection
              required
              startDate={newDraftStartDate}
              endDate={newDraftEndDate}
              onChange={period => updateProps({ newDraftStartDate: period.startDate, newDraftEndDate: period.endDate, createDraftError: '' })}
            />
          </div>
        )
      }
      <label><b>Please select a rate type:</b></label>
      <RateTypeForm
        rateType={draftRateType}
        commissionPercentage={draftCommissionPercentage}
        nettCommission={draftNettCommission}
        updateRateType={(value) => updateProps({ draftRateType: value })}
        updateCommission={(value) => updateProps({ draftCommissionPercentage: value })}
        updateNettCommission={(value) => updateProps({ draftNettCommission: value })}
      />
      <div style={{ marginTop: '16px' }}>
        <SelectLocationsProducts
          style={{ width: '80%', marginTop: '16px' }}
          hasAccessToCreateLoc
          locations={locations}
          updateProps={updateProps}
          checkAllLocations={checked => {
            const updatedLocations = locations.map(loc => {
              return R.merge(loc, {
                checked,
                products: loc.products.map(R.merge(R.__, { checked })),
              });
            });
            updateProps({ locations: updatedLocations, createDraftError: '' });
          }}
          checkLocation={(locationIndex, checked) => {
            const updatedLocations = fromJS(locations).setIn([locationIndex, 'checked'], checked)
              .updateIn([locationIndex, 'products'], products => products.map(product => product.set('checked', checked))).toJS();
            updateProps({ locations: updatedLocations, createDraftError: '' });
          }}
          checkProduct={(locationIndex, productIndex, checked) => {
            const updatedLocations = fromJS(locations).setIn([locationIndex, 'products', productIndex, 'checked'], checked).toJS();
            updateProps({ locations: updatedLocations, createDraftError: '' });
          }}
        />
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/app/components/contracting/dummy-account/create-dummy-templates-wizard/template-draft-form.jsx